import styled from 'styled-components';
import { FONT_SIZE } from '@app/styles/themes/constants';
import { BaseMenu } from '@app/components/common/BaseMenu/BaseMenu';

export const Menu = styled(BaseMenu)`
  background: transparent;
  border-right: 0;

  a {
    width: 100%;
    display: block;
  }

  .ant-menu-item,
  .ant-menu-submenu {
    font-size: ${FONT_SIZE.xs};
    height: 60px;
    line-height: 60px;
  }

  .ant-menu-item > .ant-menu-title-content{
    margin-left: 0.5rem;
  }

  .ant-menu-item-icon {
    width: 2rem;
  }

  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow,
  span[role='img'],
  a,
  .ant-menu-item,
  .ant-menu-submenu {
    color: var(--text-sider-secondary-color);
    fill: var(--text-sider-secondary-color);
    font-size: 1rem;

    .anticon {
      font-size: 1.25rem !important;
    }
  }

  .ant-menu-item:hover,
  .ant-menu-submenu-title:hover {
    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    span[role='img'],
    a,
    .ant-menu-item-icon,
    .ant-menu-title-content {
      color: var(--text-sider-primary-color);
      fill: var(--text-sider-primary-color);
    }
  }

  .ant-menu-submenu-selected {
    .ant-menu-submenu-title {
      color: var(--text-sider-primary-color);
      background-color: #5d7ef1 !important;

      .ant-menu-submenu-expand-icon,
      .ant-menu-submenu-arrow,
      span[role='img'] {
        color: var(--text-sider-primary-color);
        fill: var(--text-sider-primary-color);
      }
    }
  }

  .ant-menu-submenu-popup {
    .ant-menu-title-content {
       a{
          font-size: 1rem;
        }
    }
  }
  .ant-menu-item {
    
  }
  .ant-menu-item-selected {
    background-color: #5d7ef1 !important;

    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    span[role='img'],
    .ant-menu-item-icon,
    a {
      color: var(--text-sider-primary-color);
      fill: var(--text-sider-primary-color);
    }
  }
  .ant-menu-item-selected {
    background-color: transparent !important;
    .ant-image {
      .ant-menu-item-icon {
        
      }
    }
    a {
      color: var(--text-sider-secondary-color) !important;
      fill: var(--text-sider-secondary-color) !important;
    }
  }

  .ant-menu-item-active,
  .ant-menu-submenu-active .ant-menu-submenu-title {
      background-color: #5d7ef1;
  }
  
`;
